(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sb-before-after-carousel')) {
    class SbBeforeAfterCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-bac-track]');
        this.slides = this.track ? Array.from(this.track.children) : [];
        this.dots = Array.from(this.querySelectorAll('[data-bac-dot]'));
        this.prevBtn = this.querySelector('[data-bac-prev]');
        this.nextBtn = this.querySelector('[data-bac-next]');
        this.currentIndex = 0;

        this.setUpComparisons();
        if (this.slides.length > 1) this.setUpCarousel();
      }

      // Each slide's range input drives its own --sb-bac-pos custom property
      setUpComparisons() {
        this.querySelectorAll('[data-bac-compare]').forEach((compare) => {
          const range = compare.querySelector('[data-bac-range]');
          if (!range) return;

          const apply = () => {
            compare.style.setProperty('--sb-bac-pos', range.value + '%');
          };

          apply();
          range.addEventListener('input', apply);
        });
      }

      setUpCarousel() {
        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.goTo(i));
        });

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                const idx = this.slides.indexOf(entry.target);
                if (idx > -1) this.setActive(idx);
              }
            });
          },
          { root: this.track, threshold: [0.6] }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      // Scrolls only the track horizontally — never the page vertically
      goTo(index) {
        const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
        const trackRect = this.track.getBoundingClientRect();
        const slideRect = this.slides[clamped].getBoundingClientRect();
        const delta = slideRect.left - trackRect.left;
        this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: 'smooth' });
        this.setActive(clamped);
      }

      setActive(index) {
        this.currentIndex = index;
        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('sb-before-after-carousel', SbBeforeAfterCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sb-hero-slider')) {
    class SbHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.slides = this.track ? Array.from(this.track.children) : [];
        this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
        this.prevBtn = this.querySelector('[data-slider-prev]');
        this.nextBtn = this.querySelector('[data-slider-next]');
        this.currentIndex = 0;
        this.autoplayMs = parseInt(this.dataset.autoplay || '0', 10);
        this.timer = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.slides.length === 0) return;

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.goTo(i));
        });

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                const idx = this.slides.indexOf(entry.target);
                if (idx > -1) this.setActive(idx);
              }
            });
          },
          { root: this.track, threshold: [0.6] }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));

        if (this.autoplayMs > 0 && !this.reducedMotion && this.slides.length > 1) {
          this.startAutoplay();
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
          this.track.addEventListener('touchstart', () => this.stopAutoplay(), { passive: true });
          this.track.addEventListener('focusin', () => this.stopAutoplay());
          this.track.addEventListener('focusout', () => this.startAutoplay());
        }
      }

      goTo(index) {
        const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
        const targetSlide = this.slides[clamped];
        const trackRect = this.track.getBoundingClientRect();
        const slideRect = targetSlide.getBoundingClientRect();
        const delta = slideRect.left - trackRect.left;
        this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: 'smooth' });
        this.setActive(clamped);
      }

      setActive(index) {
        this.currentIndex = index;
        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      startAutoplay() {
        this.stopAutoplay();
        this.timer = setInterval(() => {
          const next = (this.currentIndex + 1) % this.slides.length;
          this.goTo(next);
        }, this.autoplayMs);
      }

      stopAutoplay() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('sb-hero-slider', SbHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sb-premium-ingredients')) {
    class SbPremiumIngredients extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-sb-pi-reveal]'));
        this.blobs = Array.from(this.querySelectorAll('[data-sb-pi-parallax]'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.setUpReveal();
        this.setUpParallax();
      }

      setUpReveal() {
        if (this.cards.length === 0) return;

        if (this.reducedMotion || !('IntersectionObserver' in window)) {
          this.cards.forEach((card) => card.classList.add('is-visible'));
          return;
        }

        this.revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.revealObserver.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
        );

        this.cards.forEach((card) => this.revealObserver.observe(card));
      }

      setUpParallax() {
        if (this.blobs.length === 0 || this.reducedMotion) return;

        this.ticking = false;
        this.handleScroll = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
      }

      handleScroll() {
        if (this.ticking) return;
        this.ticking = true;

        requestAnimationFrame(() => {
          const rect = this.getBoundingClientRect();
          const viewportH = window.innerHeight || document.documentElement.clientHeight;
          const progress = (viewportH - rect.top) / (viewportH + rect.height);
          const clamped = Math.max(0, Math.min(1, progress));

          this.blobs.forEach((blob) => {
            const speed = parseFloat(blob.dataset.sbPiParallax) || 0.1;
            const offset = (clamped - 0.5) * speed * 200;
            blob.style.transform = `translateY(${offset}px)`;
          });

          this.ticking = false;
        });
      }

      disconnectedCallback() {
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.handleScroll) window.removeEventListener('scroll', this.handleScroll);
      }
    }

    customElements.define('sb-premium-ingredients', SbPremiumIngredients);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('sb-product-form')) {
    class SbProductForm extends HTMLElement {
      connectedCallback() {
        this.setUpGallery();
        this.setUpQuantity();
        this.setUpVariants();
      }

      setUpGallery() {
        const thumbs = Array.from(this.querySelectorAll('[data-pp-thumb]'));
        const mainImg = this.querySelector('[id^="sb-pp-main-img-"]');
        if (!thumbs.length || !mainImg) return;

        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const src = thumb.dataset.fullSrc;
            if (src) mainImg.src = src;
            thumbs.forEach((t) => t.classList.remove('is-active'));
            thumb.classList.add('is-active');
          });
        });
      }

      setUpQuantity() {
        const minus = this.querySelector('[data-pp-qty-minus]');
        const plus = this.querySelector('[data-pp-qty-plus]');
        const input = this.querySelector('[data-pp-qty-input]');
        if (!minus || !plus || !input) return;

        minus.addEventListener('click', () => {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        });
        plus.addEventListener('click', () => {
          input.value = (parseInt(input.value, 10) || 1) + 1;
        });
      }

      setUpVariants() {
        const radios = Array.from(this.querySelectorAll('[data-pp-variant]'));
        const priceEl = this.querySelector('[data-pp-price]');
        const compareEl = this.querySelector('[data-pp-compare]');
        if (!radios.length || !priceEl) return;

        radios.forEach((radio) => {
          radio.addEventListener('change', () => {
            if (!radio.checked) return;
            if (radio.dataset.price) priceEl.textContent = radio.dataset.price;
            if (compareEl) {
              const cmp = radio.dataset.compare;
              if (cmp && cmp !== radio.dataset.price) {
                compareEl.textContent = cmp;
                compareEl.style.display = '';
              } else {
                compareEl.style.display = 'none';
              }
            }
          });
        });
      }
    }
    customElements.define('sb-product-form', SbProductForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sb-reviews-slider')) {
    class SbReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.slides = this.track ? Array.from(this.track.children) : [];
        this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
        this.prevBtn = this.querySelector('[data-slider-prev]');
        this.nextBtn = this.querySelector('[data-slider-next]');
        this.currentIndex = 0;
        this.autoplayMs = parseInt(this.dataset.autoplay || '0', 10);
        this.timer = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.slides.length === 0) return;

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.goTo(i));
        });

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                const idx = this.slides.indexOf(entry.target);
                if (idx > -1) this.setActive(idx);
              }
            });
          },
          { root: this.track, threshold: [0.6] }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));

        if (this.autoplayMs > 0 && !this.reducedMotion && this.slides.length > 1) {
          this.startAutoplay();
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
          this.track.addEventListener('touchstart', () => this.stopAutoplay(), { passive: true });
          this.track.addEventListener('focusin', () => this.stopAutoplay());
          this.track.addEventListener('focusout', () => this.startAutoplay());
        }
      }

      goTo(index) {
        const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
        const targetSlide = this.slides[clamped];
        const trackRect = this.track.getBoundingClientRect();
        const slideRect = targetSlide.getBoundingClientRect();
        const delta = slideRect.left - trackRect.left;
        this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: 'smooth' });
        this.setActive(clamped);
      }

      setActive(index) {
        this.currentIndex = index;
        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      startAutoplay() {
        this.stopAutoplay();
        this.timer = setInterval(() => {
          const next = (this.currentIndex + 1) % this.slides.length;
          this.goTo(next);
        }, this.autoplayMs);
      }

      stopAutoplay() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('sb-reviews-slider', SbReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
